import React from 'react';
import { ReactLenis, useLenis } from 'lenis/react';
import './App.css';
import About from './components/about/About';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';
import Header from './components/header/Header';
import Home from './components/Home/Home';
import Qualification from './components/qualification/Qualification';
import ScrollUp from './components/scrollup/ScrollUp';
import Services from './components/Services/Services';
import Skill from './components/skill/Skill';
import Testimonial from './components/testimonial/Testimonial';
import Sheet from './components/Sheet/sheet'

function App() {
  const lenis = useLenis(({ scroll }) => {
    // You can handle scroll events here if needed
    console.log("Scroll position:", scroll);
  });

  return (
    <ReactLenis root>
      <Header />
      <main className="main">
        <Home />
        <About />
        <Skill />
        <Services />
        <Qualification />
        <Sheet />
        <Testimonial />
        <Contact />
      </main>
      <Footer />
      <ScrollUp />
    </ReactLenis>
  );
}

export default App;
